<template>
  <div v-if="keywords" class="keywords">
    <span>搜索关键词：</span>
    <span class="keywords-value">
      <span>{{ keywords }}</span>
      <i class="el-icon-close keywords-close" @click="onCloseClick"></i>
    </span>
  </div>
</template>
<script>
export default {
  name: "SearchKeyWords",
  computed: {
    keywords() {
      return this.$route.query.keywords;
    },
  },
  methods: {
    onCloseClick() {
      this.$route.query.keywords = "";
      let query = { ...this.$route.query };
      delete query.keywords;
      this.$router.replace({ name: this.$route.name, query });
    },
  },
};
</script>
<style lang="scss" scoped>
.keywords {
  padding: 12px 0;
  color: #666666;
  display: flex;
  align-items: center;
}
.keywords-value {
  height: 26px;
  border: 1px solid #d6d6d6;
  background: white;
  border-radius: 5px;
  box-sizing: border-box;
  line-height: 24px;
  padding: 0 12px;
  color: $primary-color;
}
.keywords-close {
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
}
</style>
